var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import InputUploader from "../../common/components/InputUploader.vue";
import AccoutCheckService from '../../api/AccoutCheckService';
import _, { cloneDeep } from 'lodash';
import EAccountType, { AccountTypeDict } from '../../enum/EAccountType';
import GLOBAL_VUE from '../../globalVue';
import { add, numAdd, numDiv, numMulti, numSub, round } from '../../helper/calucate';
import { AccountCheckRefresh } from '../../constant/eventKey';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from 'element-ui';
import InvoiceInfoDialog from '../accountcheck/components/InvoiceInfoDialog.vue';
import GenerateInvoice from '../accountcheck/components/GenerateInvoice.vue';
import CommonService from '../../api/CommonService';
import GoodService from '../../api/GoodService';
import { mapGetters, mapActions } from 'vuex';
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["Save"] = 0] = "Save";
    ESaveType[ESaveType["Submit"] = 1] = "Submit";
})(ESaveType || (ESaveType = {}));
var orderTypeList = [{
        id: "1",
        name: "入库单"
    }, {
        id: "2",
        name: "退货单"
    }, {
        id: "3",
        name: "费用单"
    }];
var minuteFlag = "扣款";
var addParamsFields = ["supplier_to_business_id", "business_id", "account_date_start", "account_date_end", "subject_id", 'statement_type'];
function summaries(param, showItems) {
    var columns = param.columns, data = param.data;
    var sums = [];
    columns.forEach(function (column, index) {
        if (index === 0) {
            sums[index] = '合计';
            return;
        }
        var showSum = showItems;
        if (showSum.indexOf(column.property) != -1) {
            var filter_1 = function (item) { return item.fee_direction_name === minuteFlag ? -item[column.property] : item[column.property]; };
            var fn = function (data) { return _.map(data, filter_1); };
            sums[index] = _.flowRight(add, fn)(data).toFixedNoZero(4);
        }
        else {
            sums[index] = '';
        }
    });
    return sums;
}
var Add = (function (_super) {
    __extends(Add, _super);
    function Add() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.handleType = "";
        _this_1.orderDetail = {
            order_document: [],
            order_types: orderTypeList.map(function (item) { return item.id; }),
            manual_entry_money: ''
        };
        _this_1.pickFields = ["total_discount_money", "order_payment_money", "shop_list", "order_list"];
        _this_1.typeDict = AccountTypeDict;
        _this_1.eType = EAccountType;
        _this_1.saveType = ESaveType;
        _this_1.orderTypeList = orderTypeList;
        _this_1.tabelHeight = document.documentElement.clientHeight - 410;
        _this_1.selection = [];
        _this_1.selectionJSON = '';
        _this_1.filter = {
            shop_ids: '-1',
            shop: ['-1'],
            depot_ids: '-1',
            depot: ['-1'],
            statement_model: 1,
            goods_type_ids: [],
            select_goods_ids: [],
            invoice_type: -1,
        };
        _this_1.shop_list = [];
        _this_1.depot_list = [];
        _this_1.version = 0;
        _this_1.invoice_type_list = [];
        _this_1.isShowTip = false;
        _this_1.cancelOtherOrderListStr = '';
        _this_1.categoryData = [];
        _this_1.goodData = [];
        return _this_1;
    }
    Add.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    Add.prototype.normalizerGoodType = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Add.prototype.watchIsDetail = function (newVal, oldVal) {
        if (this.handleType === 'edit')
            return;
        if (newVal) {
            this.filter.goods_type_ids = [];
            this.filter.select_goods_ids = [];
            this.getAddCheckDetail();
            if (newVal === 2 && !this.categoryData.length) {
                this.getCategory();
            }
        }
    };
    Add.prototype.watchFormDataGoodTypeId = function (newVal, oldVal) {
        if (this.handleType === 'edit')
            return;
        if (newVal) {
            this.getGood();
        }
    };
    Add.prototype.search = function () {
        this.getAddCheckDetail();
    };
    Add.prototype.getCategory = function () {
        var _this_1 = this;
        this.goodService.getCategory({ level: 4 }).then(function (res) {
            var DATA = res.data || {};
            _this_1.categoryData = Array.isArray(DATA.data) ? DATA.data : [];
        });
    };
    Add.prototype.getGood = function () {
        var _this_1 = this;
        this.service
            .getGoodList(__assign({ order_types: this.orderDetail.order_types.join(","), shop_ids: this.filter.shop_ids }, _.pick(this.detail, addParamsFields), { statement_model: this.filter.statement_model, select_goods_ids: this.filter.select_goods_ids.join(","), goods_type_ids: this.filter.goods_type_ids.join(','), goods_type: 1 }))
            .then(function (res) {
            var DATA = res.data || {};
            var goodData = Array.isArray(DATA.data) ? DATA.data : [];
            var shiftData = [{ supplier_goods_id: '', supplier_goods_name: '全部' }];
            _this_1.goodData = shiftData.concat(goodData);
        });
    };
    Add.prototype.getSummaries = function (param) {
        param.data = this.selection;
        var showSum = ["money", "order_tax_money"];
        if (param.columns && param.columns.length) {
            param.columns[0].colSpan = 1;
        }
        var data = summaries(param, showSum);
        var total_order_money = this.orderDetail.total_order_money =
            (this.selection).reduce(function (ori, item) {
                return item.fee_direction_name === minuteFlag ? add(ori, -item.order_money) : add(ori, item.order_money);
            }, 0);
        data[2] = "应付合计：" + total_order_money;
        this.calcDiscountRateMoney();
        return data;
    };
    Add.prototype.arraySpanMethod = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        if (rowIndex === (this.orderDetail.order_list || []).length && columnIndex === 0) {
            return [1, 2];
        }
        return [1, 1];
    };
    Add.prototype.calcDiscountRateMoney = function () {
        this.orderDetail.discount_rate_money = round(numMulti(this.orderDetail.total_order_money, numSub(1, numDiv(this.orderDetail.discount_rate, 100))), 4);
        this.discountChange();
    };
    Add.prototype.calcOrderPaymentMoney = function () {
        this.orderDetail.order_payment_money = round(numSub(this.orderDetail.total_order_money, this.orderDetail.total_discount_money), 4);
    };
    Add.prototype.discountChange = function () {
        if (this.orderDetail.discount != undefined) {
            var supplier_discount_money = this.orderDetail.discount.reduce(function (ori, item) { return add(ori, item.value); }, 0);
            this.orderDetail.total_discount_money = round(numAdd(supplier_discount_money, this.orderDetail.discount_rate_money), 4);
        }
        this.calcOrderPaymentMoney();
    };
    Add.prototype.shopChange = function () {
        this.filter.shop_ids = this.filter.shop.join(",");
        this.getAddCheckDetail(false);
    };
    Add.prototype.depotChange = function () {
        this.filter.depot_ids = this.filter.depot.join(",");
        this.getAddCheckDetail(false);
    };
    Add.prototype.invoiceTypeChange = function () {
        this.getAddCheckDetail(false);
    };
    Add.prototype.typeChange = function () {
        this.selectionJSON = JSON.stringify(this.selection);
        this.getAddCheckDetail(false);
    };
    Add.prototype.getOrderInfo = function (list) {
        var _this_1 = this;
        return list.map(function (item) {
            var resetItem = {
                order_id: item.order_id,
                order_type: item.order_type
            };
            if (_this_1.filter.statement_model === 2) {
                resetItem.order_detail_id = item.order_detail_id;
            }
            return resetItem;
        });
    };
    Add.prototype.manualEntryMoneyChange = function (value) {
        if (value) {
            var arr = value.toString().split(".");
            if (arr.length > 1 && arr[1].length > 4) {
                value = Number(arr[0] + "." + arr[1].slice(0, 4));
            }
        }
        console.log('value>>>', value);
        this.orderDetail.manual_entry_money = value;
    };
    Add.prototype.close = function () {
        GLOBAL_VUE.$emit("closeTab", this);
    };
    Add.prototype.save = function (save_type, money_confirm, upload_confirm, is_delete_other_list) {
        var _this_1 = this;
        var params = __assign({ save_type: save_type }, this.orderDetail);
        params.statement_model = this.filter.statement_model;
        params.statement_type = this.detail.statement_type;
        delete params.shop_list;
        delete params.order_list;
        params.other_order_info = this.getOrderInfo(this.selection);
        params.order_types = params.order_types.join(',');
        params.order_document = JSON.stringify((params.order_document || []).map(function (item) { return ({ url: item.url, text: item.text }); }));
        console.log('save>>>', params);
        if (this.orderDetail.statement_order_money_only_manual_entry) {
            params.other_order_info = this.getOrderInfo(this.orderDetail.order_list);
            if (this.orderDetail.manual_entry_money - this.orderDetail.order_payment_money <= this.orderDetail.statement_order_money_diff_max) {
                params.manual_entry_money = this.orderDetail.manual_entry_money;
            }
            else {
                this.$message.error('您填写的本期应结货款金额与客户系统计算出的应结金额差异过大，不可提交，请重新核算后再填写本期应结货款金额！');
                return;
            }
        }
        var errorCallBack = function (msgData) {
            _this_1.$confirm('该对账单存在反审核已废弃的对账明细，该明细单据将默认删除，是否确认？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this_1.save(save_type, money_confirm, upload_confirm, 1);
            }).catch(function () {
            });
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        if (money_confirm && money_confirm == 1) {
            params = Object.assign(params, { money_confirm: 1 });
        }
        if (upload_confirm && upload_confirm == 1) {
            params = Object.assign(params, { upload_confirm: 1 });
        }
        if (is_delete_other_list && is_delete_other_list == 1) {
            params = Object.assign(params, { is_delete_other_list: 1 });
        }
        if (this.handleType === 'edit') {
            this.service.edit(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code === 65) {
                    errorCallBack(res.data.data);
                    return;
                }
                else if (res.data.code == 80) {
                    _this_1.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }
                else if (res.data.code == 78) {
                    _this_1.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        _this_1.save(save_type, 1, null, is_delete_other_list);
                    }).catch(function () {
                    });
                    return;
                }
                else if (res.data.code == 79) {
                    _this_1.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        _this_1.save(save_type, null, 1, is_delete_other_list);
                    }).catch(function () {
                    });
                    return;
                }
                _this_1.$message.success(res.data.msg);
                var data = _.pick(res.data.data, _this_1.pickFields);
                Object.assign(_this_1.orderDetail, data);
                GLOBAL_VUE.$emit("closeTab", _this_1);
                if (save_type == _this_1.saveType.Submit) {
                    window._czc.push(["_trackEvent", '对账单列表', '提交对账单', '提交成功']);
                }
            }).catch(function (err) {
                if (save_type == _this_1.saveType.Submit) {
                    window._czc.push(["_trackEvent", '对账单列表', '提交对账单', '提交失败']);
                }
                loadingInstance.close();
                _this_1.$message.error(err.msg || err.message);
            });
        }
        else {
            this.service.create(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code === 65) {
                    errorCallBack(res.data.data);
                    return;
                }
                else if (res.data.code == 80) {
                    _this_1.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }
                else if (res.data.code == 78) {
                    _this_1.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        _this_1.save(save_type, 1, null, is_delete_other_list);
                    }).catch(function () {
                    });
                    return;
                }
                else if (res.data.code == 79) {
                    _this_1.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        _this_1.save(save_type, null, 1, is_delete_other_list);
                    }).catch(function () {
                    });
                    return;
                }
                _this_1.$message.success(res.data.msg);
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this_1);
                    if (_this_1.opener) {
                        _this_1.opener.getList();
                        GLOBAL_VUE.$emit(AccountCheckRefresh);
                    }
                }, 1000);
                window._czc.push(["_trackEvent", '对账', '添加对账单']);
                if (save_type == _this_1.saveType.Submit) {
                    window._czc.push(["_trackEvent", '对账单列表', '提交对账单', '提交成功']);
                }
            }).catch(function (err) {
                if (save_type == _this_1.saveType.Submit) {
                    window._czc.push(["_trackEvent", '对账单列表', '提交对账单', '提交失败']);
                }
                loadingInstance.close();
                _this_1.$message.error(err.msg || err.message);
            });
        }
    };
    Add.prototype.initDepot = function () {
        var _this_1 = this;
        var params = { organ_id: '' };
        this.commonService.getSupplierdepotOptions(params).then(function (res) {
            _this_1.depot_list = [{ depot_id: '-1', depot_name: '所有仓库' }].concat(res.data.data || []);
            _this_1.$forceUpdate();
        });
    };
    Add.prototype.getAddCheckDetail = function (firstLoad) {
        var _this_1 = this;
        if (firstLoad === void 0) { firstLoad = false; }
        this.initDepot();
        if (this.handleType === 'edit') {
            this.filter.statement_model = this.detail.statement_model;
            this.service.getEditCheckDetail({
                order_id: this.detail.order_id,
                shop_ids: this.filter.shop_ids,
                depot_ids: this.filter.depot_ids,
                statement_model: this.detail.statement_model,
                statement_type: this.detail.statement_type
            }).then(function (res) {
                if (firstLoad) {
                    res.data.data.subject_name = _this_1.detail.subject_name;
                    res.data.data.order_types = res.data.data.order_types.split(",");
                    _this_1.orderDetail = res.data.data;
                }
                else {
                    var data = _.pick(res.data.data, _this_1.pickFields);
                    Object.assign(_this_1.orderDetail, data);
                }
                _this_1.version = res.data.business_config_res && res.data.business_config_res.business_version;
                var cancelOtherOrderList = [];
                res.data.data.cancel_other_list.forEach(function (item) {
                    cancelOtherOrderList.push(item.other_order_code);
                });
                cancelOtherOrderList = Array.from(new Set(cancelOtherOrderList));
                _this_1.cancelOtherOrderListStr = cancelOtherOrderList.join('、');
                _this_1.isShowTip = res.data.data.cancel_other_list.length > 0;
            }).catch(function (err) {
                _this_1.$message.error(err.msg || err.message);
            });
        }
        else {
            if (firstLoad) {
                this.service.getAddCheckDetail(__assign({ order_types: this.orderTypeList.map(function (item) { return item.id; }).join(","), shop_ids: '-1', invoice_type: this.filter.invoice_type }, _.pick(this.detail, addParamsFields), { order_id: this.detail.order_id || '' })).then(function (res) {
                    if (res.data.success) {
                        if (res.data.data) {
                            _this_1.shop_list = res.data.data.shop_list || [];
                            if (_this_1.shop_list) {
                                var detail_shop_ids_1 = _this_1.detail.shop_ids.split(',');
                                var filter_shop_ids_1 = _this_1.filter.shop_ids;
                                filter_shop_ids_1 = [];
                                _this_1.shop_list.splice(0, 0, {
                                    shop_id: "-1",
                                    shop_name: "所有门店"
                                });
                                _this_1.shop_list.forEach(function (item) {
                                    if (detail_shop_ids_1.indexOf((item.shop_id + '')) != -1) {
                                        filter_shop_ids_1.push(item.shop_id);
                                    }
                                });
                                _this_1.filter.shop = filter_shop_ids_1;
                                _this_1.filter.shop_ids = filter_shop_ids_1.join(',');
                            }
                            else {
                                if (_this_1.shop_list.length) {
                                    _this_1.shop_list.splice(0, 0, {
                                        shop_id: "-1",
                                        shop_name: "所有门店"
                                    });
                                }
                            }
                            _this_1.service.getAddCheckDetail(__assign({ order_types: _this_1.orderDetail.order_types.join(","), shop_ids: _this_1.filter.shop_ids }, _.pick(_this_1.detail, addParamsFields), { order_id: _this_1.detail.order_id || '' })).then(function (res) {
                                res.data.data.subject_id = _this_1.detail.subject_id || res.data.data.subject_id;
                                res.data.data.subject_name = _this_1.detail.subject_name || res.data.data.subject_name;
                                var order_types = _this_1.orderDetail.order_types;
                                _this_1.orderDetail = __assign({}, _this_1.orderDetail, res.data.data);
                                _this_1.orderDetail.order_types = order_types;
                                var fshop_ids = _this_1.shop_list.map(function (fitem) {
                                    return fitem.shop_id;
                                });
                                _this_1.orderDetail.shop_list.forEach(function (item) {
                                    if (fshop_ids.indexOf(item.shop_id) == -1) {
                                        _this_1.shop_list.push(item);
                                    }
                                    ;
                                });
                                if (_this_1.shop_list) {
                                    _this_1.orderDetail.shop_list.forEach(function (item) {
                                        if (fshop_ids.indexOf(item.shop_id) == -1) {
                                            _this_1.shop_list.push(item);
                                        }
                                        ;
                                    });
                                }
                                else {
                                    _this_1.shop_list = _this_1.orderDetail.shop_list || [];
                                    if (_this_1.shop_list.length && _this_1.shop_list[0].shop_id !== "-1") {
                                        _this_1.shop_list.splice(0, 0, {
                                            shop_id: "-1",
                                            shop_name: "所有门店"
                                        });
                                    }
                                }
                                _this_1.orderDetail.shop_ids = _this_1.detail.shop_ids;
                                _this_1.$nextTick(function () {
                                    _this_1.$refs.table.doLayout();
                                    _this_1.$refs.table.toggleAllSelection(true);
                                });
                            }).catch(function (err) {
                                _this_1.$message.error(err.msg || err.message);
                            });
                        }
                        _this_1.version = res.data.business_config_res && res.data.business_config_res.business_version;
                    }
                    else {
                        _this_1.$message.error(res.data.msg);
                    }
                });
            }
            else {
                this.service.getAddCheckDetail(__assign({ order_types: this.orderDetail.order_types.join(","), shop_ids: this.filter.shop_ids, depot_ids: this.filter.depot_ids, invoice_type: this.filter.invoice_type }, _.pick(this.detail, addParamsFields), { statement_model: this.filter.statement_model, select_goods_ids: this.filter.select_goods_ids.join(","), goods_type_ids: this.filter.goods_type_ids.join(','), order_id: this.detail.order_id || '' })).then(function (res) {
                    res.data.data.subject_id = _this_1.detail.subject_id;
                    res.data.data.subject_name = _this_1.detail.subject_name;
                    var order_types = _this_1.orderDetail.order_types;
                    _this_1.orderDetail = __assign({}, _this_1.orderDetail, res.data.data);
                    _this_1.orderDetail.order_types = order_types;
                    var fshop_ids = _this_1.shop_list.map(function (fitem) {
                        return fitem.shop_id;
                    });
                    _this_1.orderDetail.shop_list.forEach(function (item) {
                        if (fshop_ids.indexOf(item.shop_id) == -1) {
                            _this_1.shop_list.push(item);
                        }
                        ;
                    });
                    if (_this_1.shop_list) {
                        _this_1.orderDetail.shop_list.forEach(function (item) {
                            if (fshop_ids.indexOf(item.shop_id) == -1) {
                                _this_1.shop_list.push(item);
                            }
                            ;
                        });
                    }
                    else {
                        _this_1.shop_list = _this_1.orderDetail.shop_list || [];
                        if (_this_1.shop_list.length && _this_1.shop_list[0].shop_id !== "-1") {
                            _this_1.shop_list.splice(0, 0, {
                                shop_id: "-1",
                                shop_name: "所有门店"
                            });
                        }
                    }
                    _this_1.orderDetail.shop_ids = _this_1.detail.shop_ids;
                    _this_1.$nextTick(function () {
                        _this_1.$refs.table.doLayout();
                        _this_1.$refs.table.toggleAllSelection(true);
                    });
                }).catch(function (err) {
                    _this_1.$message.error(err.msg || err.message);
                });
            }
        }
    };
    Add.prototype.selectionChange = function (selection) {
        this.selection = selection;
    };
    Add.prototype.handleSelect = function (selection, row) {
        var _this_1 = this;
        if (!row.is_pre_payment) {
            return;
        }
        var isSelect = selection.some(function (item) {
            return item.order_id === row.order_id && item.order_type == row.order_type;
        });
        var list = this.tableData.filter(function (item) {
            return item.purchase_order_order_id === row.purchase_order_order_id;
        });
        if (list.length > 1) {
            list.forEach(function (item) {
                _this_1.$refs.table.toggleRowSelection(item, isSelect);
            });
        }
        console.log('row>>>', list, selection, row);
    };
    Add.prototype.copyInvoiceInfo = function (name) {
        var _this = this;
        var text = _this.orderDetail.invoice_info && _this.orderDetail.invoice_info[name] || '';
        if (!navigator.clipboard) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            _this.$message.success("已复制剪贴板");
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            _this.$message.success("已复制剪贴板");
        }, function () {
            _this.$message.success("复制失败");
        });
    };
    Add.prototype.importInvoice = function (isEdit) {
        var _this_1 = this;
        if (isEdit === void 0) { isEdit = false; }
        var instance = this.$dialog(InvoiceInfoDialog, {
            data: {
                isEdit: isEdit,
                invoice_info: cloneDeep(this.orderDetail.invoice_info || {}),
                invoiceForm: cloneDeep(this.orderDetail.invoice_info || {}),
                invoice_status: this.orderDetail.invoice_status || 0,
                detail: this.detail,
                token: this.user.token,
                order_status_name: this.orderDetail.order_status_name,
                type: this.handleType,
                getAuth: this.getAuth,
                parentPageAuth: this.Root_PageAuth,
            }
        }, {
            title: "发票信息",
            width: 640,
            height: 560,
            zIndex: 1002,
        }).instance;
        instance.$on("submitSuccess", function (res) {
            console.log('submitSuccess>>>', res);
            if (!_this_1.detail.order_id) {
                _this_1.orderDetail.invoice_info = res;
            }
            else {
                _this_1.getAddCheckDetail(true);
            }
        });
    };
    Add.prototype.showGenerateInvoice = function () {
        var _this_1 = this;
        var instance = this.$dialog(GenerateInvoice, {
            data: {
                id: this.detail.order_id
            }
        }, {
            title: '发票开具',
            width: 440,
            height: 300,
            zIndex: 2000
        }).instance;
        instance.$on('openDocumentList', function () {
            _this_1.importInvoice(false);
            _this_1.getAddCheckDetail();
        });
        instance.$on('close', function () {
            console.log('close>>>');
            instance.$destroy();
        });
    };
    Add.prototype.getInvoiceTypeList = function () {
        var _this_1 = this;
        this.commonService.getInvoiceTypeList().then(function (res) {
            if (res.data.success) {
                _this_1.invoice_type_list = res.data.data || [];
                if (_this_1.invoice_type_list.length > 0) {
                    _this_1.filter.invoice_type = _this_1.invoice_type_list[0].id;
                }
            }
        }).catch(function (err) {
            _this_1.$message.error(err.msg || err.message);
        });
    };
    Add.prototype.mounted = function () {
        var _this_1 = this;
        console.log('detail', this.detail);
        this.detail.shop_ids = this.detail.shop_ids || "-1";
        if (this.detail.business_type == 2) {
            this.orderTypeList = [{
                    id: "2",
                    name: "退货单"
                }, {
                    id: "4",
                    name: "送货单"
                },
                {
                    id: "5",
                    name: "售后工单"
                },
                {
                    id: "6",
                    name: '费用单'
                }
            ];
            this.orderDetail.order_types = ['2', '4', '5', '6'];
        }
        this.getInvoiceTypeList();
        this.getAddCheckDetail(true);
        setTimeout(function () {
            _this_1.tabelHeight = document.documentElement.clientHeight - 410;
        }, 300);
    };
    Add.prototype.isShowStatus = function () {
        var flag = false;
        if (this.orderDetail.from_system == 1) {
            if (!this.orderDetail.invoice_info.taxnumber || this.orderDetail.invoice_info.taxnumber == null) {
                flag = false;
            }
            else {
                flag = true;
            }
        }
        else {
            flag = false;
        }
        ;
        return flag;
    };
    Add.prototype.handleCloseTip = function () {
        this.isShowTip = false;
    };
    Add.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
        this.commonService = CommonService.getInstance();
        this.goodService = GoodService.getInstance();
    };
    Add.prototype.updated = function () {
        var _this_1 = this;
        this.$nextTick(function () {
            _this_1.$refs.table.doLayout();
        });
    };
    __decorate([
        Watch('filter.statement_model')
    ], Add.prototype, "watchIsDetail", null);
    __decorate([
        Watch('filter.goods_type_ids')
    ], Add.prototype, "watchFormDataGoodTypeId", null);
    Add = __decorate([
        auth(nameDict["客户对账单"], true),
        Component({
            components: {
                InputUploader: InputUploader
            },
            methods: __assign({}, mapActions(["getAuth"])),
            computed: __assign({ isShowSubject: function () {
                    var statement_name = this.orderDetail.statement_name;
                    var isManyShop = this.orderDetail.statement_type === this.eType.ManyShop;
                    var isCustomer = this.orderDetail.statement_type === this.eType.Customer;
                    return statement_name && !isManyShop && !isCustomer;
                },
                tableData: function () {
                    return this.orderDetail.type == 2 ? this.orderDetail.purchase_order_order_list : this.orderDetail.order_list;
                },
                isShowPrePayment: function () {
                    return this.version >= 3230501;
                } }, mapGetters({
                "user": "user"
            }))
        })
    ], Add);
    return Add;
}(Vue));
export default Add;
